import $ from "jquery";

const $body = $("body");
const $html = $("html");

export const bodyAddClass = (className) => {
  $body.addClass(className);
};

export const bodyRemoveClass = (className) => {
  $body.removeClass(className);
};

export const bodyToggleClass = (className, state) => {
  $body.toggleClass(className, state);
};

export const htmlAddClass = (className) => {
  $html.addClass(className);
};

export const htmlRemoveClass = (className) => {
  $html.removeClass(className);
};

export const htmlToggleClass = (className, state) => {
  $html.toggleClass(className, state);
};
